import React from 'react';

import { ConfirmModal, AlertTriangleFillIcon } from '@metarouter-private/mr-mui';
import useOverrideOrganization from '@ion/api/auth0/organization-override/useOverrideOrganization';
import { useUserContext } from '@ion/user/context/UserContext';

import useAfterOrgSwitch from 'app/after-org-switch';
import { useOrgOverrideModalContext } from 'app/settings/organization-override-page/components/OrgOverrideModalContext';

import ConfirmOverrideMessage from './ConfirmOverrideMessage';

export default function ConfirmOverrideModal() {
  const { selectedOrganization, isModalOpen, closeModal } = useOrgOverrideModalContext();
  const afterOrgSwitch = useAfterOrgSwitch();
  const { currentOrg } = useUserContext();
  
  const [overrideOrganization] = useOverrideOrganization({
    onCompleted: () => {
      afterOrgSwitch({ orgId: currentOrg.id, isOverride: true });
    },
  });
  
  if (!selectedOrganization) return null;
  
  const handleConfirm = () => {
    overrideOrganization({
      orgId: selectedOrganization.id,
      organizationName: selectedOrganization.display_name,
    });
  };

  return (
    <ConfirmModal
      open={isModalOpen}
      onClose={closeModal}
      title={`Override into ${selectedOrganization.display_name}`}
      TitleIcon={AlertTriangleFillIcon}
      message={<ConfirmOverrideMessage />}
      onConfirm={handleConfirm}
      confirmLabel="Initiate Override"
    />
  );
}
